import { chameleonSvg } from '../Svg';
import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonAccordion } from './Accordion.definition';
import { chameleonAccordionItem } from './AccordionItem/AccordionItem.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonAccordion({ prefix }), chameleonAccordionItem({ prefix }), chameleonSvg({ prefix }));
}
